export enum CdnProvider {
  AKAMAI = 'akamai',
  BITGRAVITY = 'bitgravity',
  CHINACACHE = 'chinacache',
  CLOUDFLARE = 'cloudflare',
  CLOUDFRONT = 'cloudfront',
  FASTLY = 'fastly',
  MAXCDN = 'maxcdn',
}
